/* SEAMS: full-width ADD TO BAG bar on product cards.
   Approved code exception (20 Aug notes). Adds straight to cart and opens the cart drawer. */
(function () {
  if (window.__seamsAddToBag) return;
  window.__seamsAddToBag = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-seams-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    /* data-qty lets one button add several — the sanitiser's 3 for 2 (Karen, 22 Sep) */
    const qty = Number(btn.getAttribute('data-qty')) > 0 ? Number(btn.getAttribute('data-qty')) : 1;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      });
      if (!res.ok) throw new Error('add failed');

      const ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      ev.action = 'add';
      ev.source = 'seams-add-to-bag';
      document.dispatchEvent(ev);

      btn.textContent = 'ADDED';
    } catch (err) {
      btn.textContent = 'TRY AGAIN';
    }

    setTimeout(function () {
      btn.textContent = label;
      btn.disabled = false;
    }, 1500);
  });
})();

/* SEAMS: CHECKOUT button on product pages — adds the selected variant, then goes to checkout. */
(function () {
  if (window.__seamsCheckout) return;
  window.__seamsCheckout = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-seams-checkout]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const form = document.querySelector('form[action*="/cart/add"]');
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    const variantId = idInput ? idInput.value : btn.getAttribute('data-variant-id');
    const qty = qtyInput && Number(qtyInput.value) > 0 ? Number(qtyInput.value) : 1;
    if (!variantId) return;

    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ONE MOMENT…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    } catch (err) {
      btn.textContent = label;
      btn.disabled = false;
    }
  });
})();
